export const isMatchedFieldPath = ({
  fieldPath,
  pattern
}: { fieldPath: string; pattern: string }): boolean => {
  if (!pattern.includes('*')) {
    return fieldPath === pattern
  }

  const escapedPattern = escapeRegExp(pattern)
  const regex = new RegExp(escapedPattern.replace('\\*', '.*?'))
  return regex.test(fieldPath)
}

function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
